function am_radioCheck() {
    let y = $('.am-checked-radio:checked').val();
    document.querySelector('.am-quantity-show').innerHTML = y;
}

function am_slide_dropdown() {
    $('.am-variant-picker__radio-button').addClass('am-variant-picker__dropdown-slide');
    $('.am-product-varient__drawer--mobile').addClass('-open');
    $('body').addClass('varient-drawer-open');
}

function am_varient_drawerClose(e) {
    if (e.target.nodeName === 'INPUT') {
        return;
    }
    $('.am-variant-picker__radio-button').removeClass('am-variant-picker__dropdown-slide');
    $('.am-product-varient__drawer--mobile').removeClass('-open');
    $('body').removeClass('varient-drawer-open');

}